import { render, staticRenderFns } from "./PresaleLogin.vue?vue&type=template&id=cd4d7650&scoped=true&lang=html"
import script from "./PresaleLogin.vue?vue&type=script&lang=js"
export * from "./PresaleLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4d7650",
  null
  
)

export default component.exports